module.exports = __webpack_public_path__ + "img/img44.a6a362bb.png";